<template>
    <div class="margin-20">
        <div class="page-container">
            <FilterPageList ref="pageListRef" :get-data="getJobHistory" :total="total" :order-by="orderBy" :filters="filters" v-loading="tableLoading" element-loading-text="请稍等···">
                <template slot-scope="scope">
                    <el-form :inline="true" class="table-filter">
                        <!--<el-form-item label="">-->
                            <!--<el-select style="width: 140px;" v-model="filters.jobType.value" @change="scope.search">-->
                                <!--<el-option label="全部类型" value=""></el-option>-->
                                <!--<el-option v-for="item in jobTypes" :label="item.label" :value="item.value" :key="item.value"></el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                        <el-form-item label="">
                            <el-select style="width: 140px;" v-model="filters.jobResult.value" @change="scope.search">
                                <el-option label="全部状态" value=""></el-option>
                                <el-option v-for="item in jobResults" :label="item.label" :value="item.value" :key="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="fa fa-repeat" @click="selectColumnChange();scope.search()">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="page-table" v-loading="loading" element-loading-text="请稍等···">
                        <div class="page-table-header">
                            <div class="page-table-header-title"><i class="fa fa-list"></i>作业执行日志列表
                                <el-button type="text" @click="scope.search"><i class="fa fa-refresh"></i></el-button>
                            </div>
                            <div class="page-table-header-separator"></div>
                            <div>
                                <el-button @click="batchDelete()" v-if="$common.hasPerm('job:batchRemove', domainName)"><i class="fa fa-trash text-danger"></i>删除</el-button>
                            </div>
                            <div class="pull-right">
                                <!--<el-button @click="handleAdd()" v-if="$common.hasPerm('job:add', domainName)"><i class="fa fa-plus-circle text-btn"></i>添加</el-button>-->
                            </div>
                        </div>
                        <el-table stripe border ref="multipleTable" @selection-change="handleSelectionChange" :data="JobHistoryList" @sort-change="scope.onSortChange" style="width: 100%">
                            <el-table-column type="selection"></el-table-column>
                            <!--<el-table-column prop="appKey" label="执行类型" sortable="custom" width="120px">-->
                                <!--<template slot-scope="scope">-->
                                    <!--<el-tag v-if="scope.row.namespace === '' " :type="'success'" close-transition>定时作业</el-tag>-->
                                    <!--<el-tag v-else :type="'warning'" close-transition>立即执行作业</el-tag>-->
                                <!--</template>-->
                            <!--</el-table-column>-->
                            <el-table-column prop="topic" label="自定义参数" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{scope.row.jobParameter}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="execTime" label="执行耗时 秒" width="100px">
                                <template slot-scope="scope">
                                    {{scope.row.execTime}}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" prop="jobResult" width="90px">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.jobResult === true ? 'success' : 'warning'" close-transition>{{translateJobResult[scope.row.jobResult]}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="作业执行时间" prop="createTime" width="160px">
                                <template slot-scope="scope">
                                    {{scope.row.createTime | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="jobResultReason" show-overflow-tooltip label="失败原因">
                                <template slot-scope="scope"> 
                                    {{scope.row.jobResultReason}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120px" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip content="删除" placement="top" >
                                        <el-button type="text" icon="el-icon-delete text-danger" @click="handleDelete(scope.row)"></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </FilterPageList>
        </div>
    </div>
</template>

<script>


export default {
  data() {
    return {
      loading: false,
      tableLoading: false,
      filters: {
        appKey: { value: '' },
        jobResult: { value: '', precise: true },
        jobType: { value: '' },
        siteId: { value: '' },
        topic: { value: '' },
      },
      jobTypes: [{
        value: 'Time',
        label: '定时作业',
      }, {
        value: 'www.abc.com',
        label: '立即执行作业',
      }],
      jobResults: [{
        value: true,
        label: '成功',
      }, {
        value: false,
        label: '失败',
      }],
      JobHistoryList: [],
      total: 0,
      orderBy: '',
      selectColumn: 'appKey',
      translateJobResult: {
        true: '成功',
        false: '失败',
      },
      multipleSelection: [],
    };
  },
  methods: {
    selectColumnChange() {
      this.filters.jobResult.value = '';
      this.filters.jobType.value = '';
    },

    getJobHistoryIdsArray(arr) {
      const jobHistoryIdsArray = [];
      arr.forEach((ele) => {
        jobHistoryIdsArray.push(ele.id);
      });
      return jobHistoryIdsArray;
    },

    batchDelete() {
      this.batchOperation('删除', (arr) => {
        const selectedJobHistoryArray = arr;
        if (selectedJobHistoryArray.length === 0) {
          this.$message.errorMessage('没有可以删除的作业执行日志,请勾选!');
        } else {
          const confirmText = selectedJobHistoryArray.length < 10 ? '确认删除作业执行日志吗?' : `确认删除已选的 ${selectedJobHistoryArray.length} 条作业执行日志吗?`;
          this.$message.confirmMessage(confirmText, () => {
            const params = {
              jobHistoryIds: this.getJobHistoryIdsArray(selectedJobHistoryArray).join(','),
            };
            this.$http.delete(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobHistory/batchRemoveJobHistory`, params).then(() => {
              this.refreshPage();
              this.$message.successNotify('批量删除作业执行日志操作成功');
            })
            .catch(() => { this.$http.buildErrorHandler('批量删除作业执行日志请求失败！'); });
          });
        }
      });
    },
    batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage(`请选择要批量${text}的作业执行日志！！！`);
      } else {
        const selectedJobHistoryArray = [];
        this.multipleSelection.forEach((element) => {
          selectedJobHistoryArray.push(element);
        });
        callback(selectedJobHistoryArray);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(row) {
      this.$message.confirmMessage('确认删除作业执行日志吗?', () => {
        const params = {
          jobHistoryIds: row.id,
        };
        this.$http.delete(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobHistory/batchRemoveJobHistory`, params).then(() => {
          this.refreshPage();
          this.$message.successNotify('删除作业执行日志操作成功');
        })
        .catch(() => { this.$http.buildErrorHandler('删除作业执行日志请求失败！'); });
      });
    },
    getJobHistory(params) {
      this.tableLoading = true;
      this.$http.get(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobHistory`, params).then((data) => {
        this.JobHistoryList = data.jobHistoryPage;
        this.total = data.totalCount;
      })
      .catch(() => { this.$http.buildErrorHandler('获取作业执行日志列表请求失败！'); })
      .finally(() => {
        this.tableLoading = false;
      });
    },
    refreshPage() {
      this.$refs.pageListRef.search();
    },
  },
  created() {
  },
  watch: {
    $route: 'init',
  },
  computed: {
    domainName() {
      return this.$route.params.domain;
    },
    jobName() {
      return this.$route.params.jobName;
    },
    filterColumnPlaceholder() {
      let str = '';
      switch (this.selectColumn) {
        case 'appKey':
          str = '请输入AppKey';
          break;
        case 'siteId':
          str = '请输入站点ID';
          break;
        case 'topic':
          str = '请输入消息主题';
          break;
        default:
          str = '';
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="sass" scoped>
.devicon-java-plain:before {
    content: "\F144";
}
</style>



// WEBPACK FOOTER //
// job_history.vue?31ea6b93